import styled from '@emotion/styled'
import { TextLink } from '../typography/TextLink/TextLink'
import { calcRem } from '../__styling'

export const BottomTextWrap = styled('div')(({ theme }) => ({
    display: 'block',
    marginTop: calcRem(18),
}))

export const InfoText = styled('p')(({ theme }) => ({
    fontFamily: theme.fonts.sansSerif,
}))

export const InfoTextLink = styled(TextLink)(({ theme }) => ({
    fontFamily: theme.fonts.sansSerif,
    textDecoration: 'underline',
}))
